import './inventoryProductTypes.css'
import React, {useState} from 'react'
import Table from "react-bootstrap/lib/Table";
import AccordionBtn from "./components/AccordionBtn";

function InventoryProductTypes({productTypes}) {

  const [showAccordion, setShowAccordion] = useState(true);

  const openAccordion = () => {
    setShowAccordion(!showAccordion)
  }

  return (
    <div className="product-container">
      <AccordionBtn
        showAccordion={showAccordion}
        onClick={openAccordion}
        label="Produtos Parciais"
      />
      {showAccordion &&
        <Table className="table-container">
          <thead>
          <tr>
            <th>Referência</th>
            <th>Nome</th>
          </tr>
          </thead>
          <tbody>
          {productTypes && productTypes.map(x => <tr>
            <td>
              {x.reference}
            </td>
            <td>
              {x.friendlyName}
            </td>
          </tr>)}
          </tbody>
        </Table>
      }
    </div>
  )
}

export default InventoryProductTypes



// WEBPACK FOOTER //
// ./src/Inventory/InventoryProductTypes.js